export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8510.c31533f8.jpg";